import { render } from "./DetailSettings.vue?vue&type=template&id=1eca2c2b&scoped=true"
import script from "./DetailSettings.vue?vue&type=script&lang=js"
export * from "./DetailSettings.vue?vue&type=script&lang=js"

import "./DetailSettings.vue?vue&type=style&index=0&id=1eca2c2b&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eca2c2b"]])

export default __exports__